import { ActivatedRouteSnapshot } from '@angular/router';
import { contactDetailTokenizer } from '../store/token/contact.token';
import { profilePageTokenizer } from "@data-access/profiles";

export const contactResolver = (route: ActivatedRouteSnapshot) => {
  const _contactSignalStore = contactDetailTokenizer();
  const contactId = route.paramMap.get('id');
  _contactSignalStore.loadContact(contactId!);
  _contactSignalStore.loadDegrees();
  _contactSignalStore.loadSpecialties();
  _contactSignalStore.loadCountries();
  return !!_contactSignalStore;
};


export const profileResolver = (route: ActivatedRouteSnapshot) => {
  const _profileTokenizer = profilePageTokenizer();
  const _userId = route.paramMap.get('id');
  _profileTokenizer.loadProfile(true, _userId!);
  _profileTokenizer.loadCountries();
  _profileTokenizer.loadDegrees();
  _profileTokenizer.loadSpecialties();
  _profileTokenizer.loadRolesAndAttributes();
  return !!_profileTokenizer;
}
